import { render, staticRenderFns } from "./closeTask.vue?vue&type=template&id=4e2e6863&scoped=true&"
import script from "./closeTask.vue?vue&type=script&lang=js&"
export * from "./closeTask.vue?vue&type=script&lang=js&"
import style0 from "./closeTask.vue?vue&type=style&index=0&id=4e2e6863&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2e6863",
  null
  
)

export default component.exports